/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetCurrentCurrencyRate$Params {
  currencyKey: string;
  currencyRateDate: string;
}

export function getCurrentCurrencyRate(
  http: HttpClient,
  rootUrl: string,
  params: GetCurrentCurrencyRate$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<{}>> {
  const rb = new RequestBuilder(rootUrl, getCurrentCurrencyRate.PATH, 'get');
  if (params) {
    rb.path('currencyKey', params.currencyKey, {});
    rb.path('currencyRateDate', params.currencyRateDate, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{}>;
    }),
  );
}

getCurrentCurrencyRate.PATH = '/service/v1/currency/{currencyKey}/{currencyRateDate}';
